// app/javascript/projects/components/ProjectsDisplay.jsx

import React, { useEffect } from 'react';
import AccountSingleButton from '../AccountSingleButton'
import { useSubscription } from '../../../hooks/subscriptions/queries';
import { useUpgradeInfo } from '../../../hooks/upgrades/queries';
import { useUpgradeSubscription } from '../../../hooks/upgrades/mutations';
import { useTeamModal } from 'contexts/TeamModalContext';
import AccountPageConstants from 'constants/AccountPageConstants';
import { isMonthly as checkIsMonthly, isAnnual as checkIsAnnual } from '../../../utils/subscriptionUtils';
import { 
  ANNUAL_DISCLAIMER, 
  MONTHLY_DISCLAIMER,
} from './BillingConstants'

const BillingModalUpgrade = () => {
  const { navigateToPage } = useTeamModal();
  
  // Get subscription data from hooks
  const { data: subscription } = useSubscription();
  const isMonthly = checkIsMonthly(subscription);
  const isAnnual = checkIsAnnual(subscription);
  
  // Fetch upgrade info from API
  const { data: upgradeInfo, isLoading, error } = useUpgradeInfo();
  const upgradeSubscriptionMutation = useUpgradeSubscription();
  
  const upgradeSubscription = (e) => {
    if (upgradeInfo?.plan_id) {
      upgradeSubscriptionMutation.mutate(upgradeInfo.plan_id);
    }
  }
  
  // Handle successful mutation
  useEffect(() => {
    if (upgradeSubscriptionMutation.isSuccess) {
      navigateToPage(AccountPageConstants.PLAN_AND_BILLING);
    }
  }, [upgradeSubscriptionMutation.isSuccess, navigateToPage])

  const proposedBillingType = isAnnual ? 'Monthly' : 'Annual';
  const proposedInterval = isAnnual ? 'month' : 'year';
  const disclaimer = isAnnual ? MONTHLY_DISCLAIMER : ANNUAL_DISCLAIMER;

  return (
    <div>
      <AccountSingleButton
        error={(error || upgradeSubscriptionMutation.error) ? { error: true, message: 'Something went wrong, please refresh and try again.' } : null}
        loading={isLoading || upgradeSubscriptionMutation.isPending}
        header={`Switch to ${proposedBillingType} Billing`}
        button={`Confirm Switching to ${proposedBillingType}`}
        disclaimer={disclaimer}
        onClick={upgradeSubscription}
        body={
          <div>
            <p>
              You will be billed ${upgradeInfo?.upgrade_per_person || 0} a {proposedInterval} per teammember
              at a total of ${upgradeInfo?.upgrade_amount_total || 0} per {proposedInterval}.
            </p>
            {upgradeInfo?.upgrade_savings > 0 && isMonthly &&
              <p>
                You'll save ${upgradeInfo.upgrade_savings} a year by paying annually!
              </p>
            }
          </div>
        }
      />
    </div>
  );
};

export default BillingModalUpgrade;
